export default class extends HTMLElement {
  connectedCallback () {
    const hash = window.location.hash.slice(1)

    if (!hash) return

    const values = JSON.parse(this.dataset.values)
    const [framework, ...rest] = hash.split('.')

    if (values.includes(framework)) {
      const anchor = rest.length > 0 ? `#${rest.join('.')}` : ''

      window.location.replace(`${window.location.pathname}/${framework}${anchor}`)
    }
  }
}
